import { render } from "./dialog2.vue?vue&type=template&id=9da2030c&scoped=true"
import script from "./dialog2.vue?vue&type=script&lang=js"
export * from "./dialog2.vue?vue&type=script&lang=js"

import "./dialog2.vue?vue&type=style&index=0&id=9da2030c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da2030c"]])

export default __exports__